module.exports = __webpack_public_path__ + "img/faultIcon.4bd01b96.png";